import { GROUND_LEVEL, GROUND_WIDTH } from "./constants";
import { Box } from "./react-graphics";

const Ground = () => {
  return (
    <Box
      x={-GROUND_WIDTH / 2}
      y={-GROUND_LEVEL}
      width={GROUND_WIDTH}
      height={50}
      fillColor={0x773322}
    />
  );
};

export default Ground;
